<template>
  <modal title="Confirmation" size="xs" ref="modal">
    <client-loader :client-id="clientId" v-model="client" />

    <p v-if="client" class="text-subtitle1">
      Are you sure you want to remove the <strong>{{ socialSiteName }}</strong> account
      of <strong>{{ $filters.clientName(client) }}</strong>?
    </p>
    <p class="text-subtitle1">
      All posts related to this account will be <strong>permanently deleted</strong>
      from Private Footprint. This has no impact on the client's {{ socialSiteName }} account.
    </p>
    <template v-slot:actions>
      <async-btn
        :task="task"
        label="Remove"
        color="negative"
        @click="confirm" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { Modal as ModalElement, SocialAccount, Client } from '@/type';
import notify from '@/components/notify';
import ClientLoader from '@/client/ClientLoader.vue';
import { name as clientName } from '@/client/client-filter';
import Modal from '@/components/modal/Modal.vue';
import { deleteSocialAccount } from '../..';

interface Data {
  client: Client|null,
  task: Promise<void>|null,
}

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    ClientLoader,
    Modal,
    AsyncBtn,
  },
  props: {
    socialAccount: {
      type: Object as () => SocialAccount,
      required: true,
    },
  },
  computed: {
    clientId(): number {
      return this.socialAccount.clientId;
    },
    socialSiteName(): string {
      return this.socialAccount.socialSite.name;
    },
  },
  data(): Data {
    return {
      client: null,
      task: null,
    };
  },
  methods: {
    confirm() {
      this.task = deleteSocialAccount(this.socialAccount);
      this.task.then(() => {
        notify('Social account has been removed.');
        (this.$refs.modal as ModalElement).hide();
      });
    },
  },
  filters: {
    clientName,
  },
});
</script>
